import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'

export const pageUrl = '/[locale]/fundraising-events/[slug]/manage/live-widgets/progress'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type ProgressPageProps = PageProps<typeof pageUrl>
